import { mimeTypes } from "./commonWebMimeTypes";

export function getMimeTypeByFilename(filename: string) {
  const extension = filename.toLowerCase().split(".").pop();
  const mime = mimeTypes.find((m) => m.extension === extension);

  return mime?.mimeType;
}
